export default __webpack_public_path__ + "static/media/DavisElkins.46775cb2.png";